import { TruckDto } from '@trucktrax/trucktrax-ts-common';
import { PayloadAction } from '../../types';
import { FETCH_ALL_TRUCKS, FETCH_TRUCKS } from '../../constants/actionConstants';

export const trucksReducer = (
  state = { trucks: [] as TruckDto[] },
  action: PayloadAction<TruckDto[], any>,
) => {
  switch (action.type) {
    case FETCH_TRUCKS:
      return {
        ...state,
        trucks: action.payload,
      };
    default:
      return state;
  }
};

export const allTrucksReducer = (
  state: TruckDto[] = [],
  action: PayloadAction<TruckDto[], any>,
) => {
  switch (action.type) {
    case FETCH_ALL_TRUCKS:
      return action.payload;
    default:
      return state;
  }
};
